import React from 'react';

const TempleCard = ({ 
  name, 
  location, 
  image, 
  link 
}) => {
  return (
    <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-2">
      <img 
        src={image} 
        alt={name} 
        className="w-full h-48 object-cover" 
      />
      <div className="p-4">
        <h3 className="font-bold text-orange-800 mb-2">{name}</h3>
        <p className="text-sm text-gray-600">{location}</p>
      </div>
    </div>
  );
};

export default TempleCard;
